import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { formatImage } from '@src/common/formatImage';

class ImageGallery extends PureComponent {

    static propTypes = {
        content: PropTypes.array
    }

    render() {
        const { content } = this.props;
        const [ one, two, three, four, five, six ] = content;

        return (
            <div className={styles.imageGallery}>
                <div className={styles.left}>
                    <a href={one.url} target="_blank">
                        <img src={formatImage(one.image, 281, 200)} className={styles.one} alt="" />
                    </a>
                    <a href={two.url} target="_blank">
                        <img src={formatImage(two.image, 281, 300)} className={styles.two} alt="" />
                    </a>
                </div>
                <div className={styles.right}>
                    <div>
                        <a href={three.url} target="_blank">
                            <img src={formatImage(three.image, 459, 300)} className={styles.three} alt="" />
                        </a>
                        <a href={four.url} target="_blank">
                            <img src={formatImage(four.image, 254, 300)} className={styles.four} alt="" />
                        </a>
                    </div>
                    <div>
                        <a href={five.url} target="_blank">
                            <img src={formatImage(five.image, 333, 200)} className={styles.five} alt="" />
                        </a>
                        <a href={six.url} target="_blank">
                            <img src={formatImage(six.image, 380, 200)} className={styles.six} alt="" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default ImageGallery;
